import { z } from "zod";

import { safeString } from "@/schema/public/components/base/safe-string.schema";

export const lessonOutlineSchema = z.object({
  lesson_outline: safeString,
});

export type LessonOutline = z.infer<typeof lessonOutlineSchema>;

export const lessonOutlineSchemaCamel = z.object({
  lessonOutline: z.string(),
});
export type LessonOutlineCamel = z.infer<typeof lessonOutlineSchemaCamel>;
